import React from 'react';

const ModeSelector = ({ selectedMode, onModeChange, showError }) => {
  const modes = [
    {
      id: 'whole-room',
      label: 'Whole Room Variation',
      description: 'Swap & reorganize all furniture',
    },
    {
      id: 'specific-room',
      label: 'Specific Room Only',
      description: 'Edit one zone, rest untouched',
    },
  ];

  return (
    <div>
      <div className="flex items-center gap-1 mb-3">
        <span className="text-[12.6px] font-medium text-white">Select Mode</span>
        <span className="text-red-500 text-sm">*</span>
      </div>
      <div className="flex items-end flex-wrap">
        {modes.map((mode) => {
          const isActive = selectedMode === mode.id;
          return (
            <button
              key={mode.id}
              onClick={() => onModeChange(mode.id)}
              className={`pb-3 pt-1 text-left transition-all duration-200 mr-8 ${
                isActive ? 'opacity-100' : 'opacity-40 hover:opacity-60'
              }`}
            >
              <div className="inline-flex items-baseline gap-2 px-1">
                <span className={`text-sm font-semibold tracking-wide transition-colors duration-200 ${
                  isActive ? 'text-white' : 'text-white/70'
                }`}>
                  {mode.label}
                </span>
                <span className="text-white/40 text-xs hidden sm:inline">
                  &mdash; {mode.description}
                </span>
              </div>

              {/* Orange underline for active tab - only spans text width */}
              <div className={`h-[2px] transition-all duration-300 mt-2 ${
                isActive
                  ? 'bg-orange-500 shadow-[0_0_8px_rgba(254,131,56,0.4)]'
                  : 'bg-white/10'
              }`} />
            </button>
          );
        })}
      </div>

      {/* Subtle separator line underneath */}
      {showError && !selectedMode && (
        <p className="text-red-400 text-[11px] mt-2">Please select a mode to continue</p>
      )}
    </div>
  );
};

export default ModeSelector;
